import { Reveal } from "@/components/Reveal";

const MAESTRO_IMG = "/assets/maestro-piano.jpg";

export const Maestro = () => (
    <section id="maestro" data-testid="maestro-section" className="py-24 md:py-32 bg-[#0c0c0f] border-y border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-5 gap-14 items-center">
            <Reveal className="lg:col-span-2">
                <div className="relative overflow-hidden border border-white/10">
                    <img src={MAESTRO_IMG} alt="Musical director at the grand piano" className="w-full h-[420px] lg:h-[560px] object-cover object-[42%_center] img-luxe" loading="lazy" />
                </div>
            </Reveal>
            <Reveal delay={0.15} className="lg:col-span-3">
                <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4">The Maestro</p>
                <h2 className="font-serif text-4xl sm:text-5xl tracking-tight font-light text-[#fafafa]">
                    Led by <em className="text-[#d4af37]">Allen G. Nazarian.</em>
                </h2>
                <p data-testid="maestro-title" className="mt-3 text-xs uppercase tracking-[0.3em] text-[#a1a1aa]">Musical Director</p>
                <p className="mt-8 text-base sm:text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
                    Allen G. Orchestra has been transforming weddings and international events from memorable to
                    unforgettable since 2007. Led by musical director and celebrated visionary Allen G. Nazarian, the
                    orchestra offers an extensive range of powerful live music — Top 40 hits, international classics,
                    rock, pop, classical, jazz and beyond.
                </p>
                <p className="mt-5 text-base sm:text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
                    Every engagement begins with a personal consultation, so the music on your day is unmistakably yours.
                </p>
            </Reveal>
        </div>
    </section>
);
